import { render, staticRenderFns } from "./_SolutionPreview.vue?vue&type=template&id=47f1bc62&scoped=true&"
import script from "./_SolutionPreview.vue?vue&type=script&lang=ts&"
export * from "./_SolutionPreview.vue?vue&type=script&lang=ts&"
import style0 from "./_SolutionPreview.vue?vue&type=style&index=0&id=47f1bc62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1bc62",
  null
  
)

export default component.exports